import { bootstrapApplication } from '@angular/platform-browser';

import { registerAppLocaleData } from '@neki-app/shared/services/translations/utils/register-locale-data';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

registerAppLocaleData();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
